import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CopMainComponent } from './cop-main.component';
import { UserService } from '../../../core/services/user.service';
import { UserModel } from '../../../shared/models/user.model';
import { LangSwitcherModule } from '../../../shared/components/lang-switcher/lang-switcher.module';
import { InactiveUserModule } from '../../../core/components/inactive-user/inactive-user.module';

export function userFactory(provider: UserService) {
    return () => {
        return new Promise((resolve => {
            provider.loggedUser = provider.getStoredLoggedUser() || new UserModel();
            resolve(provider.loggedUser);
        }));
    };
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        LangSwitcherModule,
        InactiveUserModule,
    ],
    declarations: [CopMainComponent],
    providers: [
        {provide: APP_INITIALIZER, useFactory: userFactory, deps: [UserService], multi: true}
    ]
})
export class CopMainModule { }
